import React from 'react';

/**
 * Stub LoadingScreen component to resolve TypeScript errors
 * This is a placeholder that should be implemented with actual functionality
 */
const LoadingScreen: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
};

export default LoadingScreen;
